import { StyleSheet } from 'react-native';

import type { useTheme } from '../theme';

// Entry card chrome: name/card/chips/banner/note-editor (Track R — split from loggerStyles.ts; pure data,
// merged by the loggerStyles barrel). Not imported directly.
export function entryStyles(theme: ReturnType<typeof useTheme>) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    body: {
      padding: s.s5,
      gap: s.s4,
      paddingBottom: s.s7,
    },
    empty: {
      color: p.ink3,
      fontSize: t.sizes.base,
      textAlign: 'center',
      paddingVertical: s.s5,
    },
    // Compact workout title (Antenore 2026-06-23): a borderless display row
    // (title + ✎ pencil) that swaps to a bordered input on tap. Far less
    // vertical space than the old labelled card, and a long name WRAPS (2
    // lines) instead of truncating inside a scrolling field.
    nameDisplayRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s.s2,
      minHeight: 44,
      paddingVertical: s.s2,
    },
    nameDisplayPressed: { opacity: 0.6 },
    nameDisplayText: {
      flex: 1,
      color: p.ink,
      fontSize: t.sizes.md,
      fontWeight: '600',
    },
    // The auto-suggested name reads slightly softer than a user-set one, so
    // it signals "default, tap to rename" rather than a committed title
    // (still ≥4.5:1 — ink2, not a muted gray).
    nameDisplayAuto: { color: p.ink2 },
    // ✎ = editable. Off-brand (ink2) per the colour budget: rename is a
    // secondary utility, not the screen's primary action.
    namePencil: {
      color: p.ink2,
      fontSize: t.sizes.md,
      paddingHorizontal: s.s2,
    },
    nameEditRow: {
      borderColor: p.borderStrong,
      borderWidth: 1,
      borderRadius: r.r2,
      paddingHorizontal: s.s3,
    },
    nameInput: {
      color: p.ink,
      fontSize: t.sizes.base,
      minHeight: 44,
      paddingVertical: s.s2,
    },
    card: {
      backgroundColor: p.surface,
      borderColor: p.border,
      borderWidth: 1,
      borderRadius: r.r3,
      padding: s.s4,
      gap: s.s3,
    },
    // Pressed-state opacity for the round icon buttons (e.g. SetTypeChipBar).
    iconButtonPressed: { opacity: 0.5 },
    // Chip row (line 2): + 📝 📊 🕐 (↔) ⋮. Slice 2 wires only `+` (group
    // picker, existing) and `↔` (bilateral, existing); the rest are
    // disabled placeholders until slice 3 (note/RPE) and slice 4 (⋮).
    entryChipRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s.s2,
      marginTop: s.s2,
    },
  });
}
